import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Button, 
  Grid 
} from '@mui/material';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

// Keyframes for animations
const rotateY = keyframes`
  0% { transform: rotateY(0deg); }
  100% { transform: rotateY(360deg); }
`;

const upDown = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(20px); }
`;

// Styled components
const BannerSection = styled(Box)(({ theme }) => ({
  backgroundImage: 'url("/assets/images/banner/style1/main-banner.png")',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  position: 'relative',
  padding: '350px 0 298px', // Match original padding
  overflow: 'hidden',
  zIndex: 111,
  width: '100vw',
  marginLeft: 'calc(-50vw + 50%)',
  marginRight: 'calc(-50vw + 50%)',
  [theme.breakpoints.down('md')]: {
    padding: '250px 0 150px',
  }
}));

const BannerContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 3,
  color: '#ffffff',
  padding: '0',
}));

const MainTitle = styled(Typography)(({ theme }) => ({
  fontSize: '84px',
  lineHeight: '84px',
  fontWeight: 800,
  color: '#ffffff',
  margin: '0px 0px 14px 0px',
  [theme.breakpoints.down('md')]: {
    fontSize: '60px',
    lineHeight: '70px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '40px',
    lineHeight: '50px',
  }
}));

const SubTitle = styled(Typography)(({ theme }) => ({
  fontSize: '53px',
  lineHeight: '63px',
  fontWeight: 700,
  color: '#ffffff',
  margin: '0px 0px 47px 0px',
  [theme.breakpoints.down('md')]: {
    fontSize: '36px',
    lineHeight: '46px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    lineHeight: '38px',
  }
}));

const BorderLine = styled(Box)(({ theme }) => ({
  backgroundColor: '#bb0b0b',
  width: '70px',
  height: '8px',
  marginBottom: '28px',
}));

const BannerButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#bb0b0b',
  color: '#ffffff',
  padding: '12px 30px',
  borderRadius: '0',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: '#d30b0d',
  }
}));

const BannerImage = styled('img')(({ theme }) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  height: '100%',
  width: '50%',
  objectFit: 'cover',
  borderRadius: '0 0 0 300px',
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    display: 'none',
  }
}));

const BannerLine = styled('img')(({ theme }) => ({
  position: 'absolute',
  right: -10,
  bottom: -40,
  width: '1030px',
  zIndex: 0,
  [theme.breakpoints.down('md')]: {
    display: 'none',
  }
}));

const AnimatePart = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  zIndex: 2,
}));

const SpinerDot = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: '46%',
  top: '30%',
  zIndex: 1,
  '& img': {
    width: '70px',
    animation: `${rotateY} 5s linear infinite`,
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
  }
}));

const SpinerCircle = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: '35%',
  bottom: '27%',
  zIndex: 0,
  '& img': {
    width: '85px',
    animation: `${upDown} 5s linear infinite`,
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
  }
}));

const SpinerTriCircle = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: '33%',
  bottom: '9%',
  zIndex: 0,
  '& img': {
    width: '150px',
    animation: `${upDown} 5s linear infinite`,
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
  }
}));

function Banner() {
  return (
    <BannerSection id="rs-banner">
      <Container maxWidth="lg">
        <BannerContent>
          <BorderLine />
          <MainTitle variant="h1">
            Cybersecurity
          </MainTitle>
          <SubTitle variant="h3">
            to the next level
          </SubTitle>
          <BannerButton variant="contained" href="#rs-contact">
            Contact Us
          </BannerButton>
        </BannerContent>
      </Container>
      
      {/* Banner Animations */}
      <AnimatePart>
        <SpinerDot>
          <img src="/assets/images/banner/style1/dot-rect.png" alt="Dots Shape" />
        </SpinerDot>
        
        <SpinerCircle>
          <img src="/assets/images/banner/style1/circle1.png" alt="Circle Shape" />
        </SpinerCircle>
        
        <SpinerTriCircle>
          <img src="/assets/images/banner/style1/tri-circle1.png" alt="Triangle Circle Shape" />
        </SpinerTriCircle>
        
        <BannerLine src="/assets/images/banner/style1/line1.png" alt="Line Shape" />
      </AnimatePart>
      

    </BannerSection>
  );
}

export default Banner;
